import PlaceResult = google.maps.places.PlaceResult

export type PlaceResultAddress = {
    address1: string
    city: string
    state: string
    zipCode: string
}

export const getAddressComponent = (result: PlaceResult, name: string): string =>
    result.address_components?.find(component => component.types.includes(name))
        ?.long_name || ""

export const parseGooglePlaceResult = (
    result: PlaceResult,
    countryCode: string | undefined
): PlaceResultAddress => {
    const streetNumber = getAddressComponent(result, "street_number")
    const route = getAddressComponent(result, "route")
    const city =
        getAddressComponent(result, "postal_town") ||
        getAddressComponent(result, "locality")
    const addressParts = [route]
    if (countryCode === "US" || countryCode === "CA" || countryCode === "AU") {
        addressParts.unshift(streetNumber)
    } else {
        addressParts.push(streetNumber)
    }
    const address1 = addressParts.join(" ")
    const zipCode = getAddressComponent(result, "postal_code")
    const state = getAddressComponent(result, "administrative_area_level_1")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
    return {
        address1,
        city,
        state,
        zipCode
    }
}
